import "./navbar.scss";
import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import Offcanvas from 'react-bootstrap/Offcanvas';
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import GridViewOutlinedIcon from "@mui/icons-material/GridViewOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import Groups from "../../assets/2.png";
import { Link } from "react-router-dom";
import { useContext } from "react";
import { DarkModeContext } from "../../context/darkModeContext";
import { AuthContext } from "../../context/authContext";
import {Buffer} from 'buffer';
import Map from "../../assets/map.png";
import Friends from "../../assets/1.png";
import Tutorials from "../../assets/11.png";
import logo from './cover.png'
import Hamburger from 'hamburger-react'
import useWindowSize from '../windowSize/useWindowSize'
import { setTranslations, setDefaultLanguage, useTranslation } from 'react-multi-lang'
import ua from '../../translate/ua/translation.json'
import en from '../../translate/en/translation.json'
function OffCanvasExample({ name, ...props }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
     
      <Hamburger toggled={show} toggle={handleShow}  onClick={handleShow} />
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>PAGES</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div>
      <Link to="/search" relative="path" style={ {textDecoration: 'none',color:'black'} }>
              <img src={Map} />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;Map</span>
            </Link>
        </div>
        <div >
        <Link to="/forum" relative="path" style={ {textDecoration: 'none',color:'black'} }>
            <img src={Groups} alt="" />
            <span>&nbsp;&nbsp;&nbsp;&nbsp;Forum</span>
            </Link>
        </div>
        <div >
        <Link to="/information" relative="path" style={ {textDecoration: 'none',color:'black'} }>
            <img src={Tutorials} alt="" />
            <span>&nbsp;&nbsp;&nbsp;Information</span>
            </Link>
        </div>
        <div >
          <Link to="/information" relative="path" style={ {textDecoration: 'none',color:'black'} }>
            <img src={Friends}  alt="" />
            <span>&nbsp;&nbsp;&nbsp;About Us</span>
            </Link>
        </div>
  
       
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}


const Navbar = () => {
  const {lang,setLang} = useContext(AuthContext);
 
  const { toggle, darkMode } = useContext(DarkModeContext);
  const { currentUser } = useContext(AuthContext);
  const [isOpen, setOpen] = useState(false)
  const size = useWindowSize();    
 
  return (
    <div className="navbar">
      <div className="left">
        <Link to="/" style={{ textDecoration: "none" }}>
          <span><img
            src={logo}
            alt="logo"
            style={{ width:'250px',height:'100%' }}
          /></span> 
          
        </Link>
        {/* <Form.Select value={lang} onChange={handleChange}>
          <option value="ua">Українська</option>
          <option value="en">English</option>
        </Form.Select> */}
        {/* <HomeOutlinedIcon /> */}
       
        
        {/* <GridViewOutlinedIcon /> */}
        {size.width > 900 &&
        <>
         {darkMode ? (
          <WbSunnyOutlinedIcon onClick={toggle} />
        ) : (
          <DarkModeOutlinedIcon onClick={toggle} />
        )}
        <div className="search">
          <SearchOutlinedIcon />
          <input className='headerInput' type="text" placeholder="Search..." />
        </div>
        </>
          }
      </div>
      <div className="right">
      {size.width >1350 &&
        <>
        
      <div className="links">
      <Link to="/search" relative="path" style={ {textDecoration: 'none',color:'black'} }>
              <img src={Map} />
              <span>&nbsp;&nbsp;&nbsp;&nbsp;Карта</span>
            </Link>
        </div>
        <div className="links">
        <Link to="/forum" relative="path" style={ {textDecoration: 'none',color:'black'} }>
            <img src={Groups} alt="" />
            <span>&nbsp;&nbsp;&nbsp;&nbsp;Форум</span>
            </Link>
        </div>
        <div className="links">
        <Link to="/information" relative="path" style={ {textDecoration: 'none',color:'black'} }>
            <img src={Tutorials} alt="" />
            <span>&nbsp;&nbsp;&nbsp;Інформація</span>
            </Link>
        </div>
        <div className="links">
          <Link to="/about" relative="path" style={ {textDecoration: 'none',color:'black'} }>
            <img src={Friends}  alt="" />
            <span>&nbsp;&nbsp;&nbsp;Про нас</span>
            </Link>
        </div>
        
        </>
}
        { currentUser.ID_user!="0" ? 
      <Link to={`/profile/${currentUser.ID_user}`} style={{ textDecoration: "none" }}>
        <PersonOutlinedIcon style={{ color: "black" }}/>
        </Link> 
        :
         <Link to="/login" style={{ textDecoration: "none" }}>
         <PersonOutlinedIcon style={{ color: "black" }}/>
         </Link>
        }
        {/* <EmailOutlinedIcon /> */}
        {/* <NotificationsOutlinedIcon /> */}
        <Link to={`/profile/${currentUser.ID_user}`} style={{ textDecoration: "none" }}>
          {currentUser.data ? 
        <div className="user">
          <img
            src={`data:${currentUser.data.type};base64,${new Buffer(currentUser.data).toString('base64')}`} 
            alt=""
          />
          <span>{currentUser.name}</span>
        </div> : ""
}
        </Link>
        {size.width < 1350 &&  <OffCanvasExample key={2} placement={'end'} name={'end'} />}
       
        
       
      </div>
    </div>
  );
};

export default Navbar;
